import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import "./AdDetailsOwnerContact.css";

const AdDetailsOwnerContact = ({ user_id, username, user_phone_number, email_confirmed }) => {
    const [showPhone, setShowPhone] = useState(false);
    const navigate = useNavigate();

    const handleViewAllAds = () => {
        navigate(`/oglasi-uporabnika/${user_id}`); // Navigate with user_id as a parameter
    };

    // Funkcija za renderiranje značke
    const renderVerificationBadge = () => {
        if (email_confirmed) {
            return (
                <OverlayTrigger
                    trigger={['hover', 'focus', 'click']}
                    rootClose
                    placement="top"
                    overlay={<Tooltip id="verified-tooltip">Preverjen uporabnik (Email potrjen)</Tooltip>}
                >
                    <span className="badge_verified" style={{ cursor: 'pointer' }}>
                        <i className="fas fa-check-circle"></i>
                    </span>
                </OverlayTrigger>
            );
        } else {
            return (
                <OverlayTrigger
                    trigger={['hover', 'focus', 'click']}
                    rootClose
                    placement="top"
                    overlay={<Tooltip id="unverified-tooltip">Uporabnik še ni potrdil emaila</Tooltip>}
                >
                    <span className="badge_unverified">
                        <i className="fas fa-exclamation-circle"></i>
                    </span>
                </OverlayTrigger>
            );
        }
    };

    return (
        <div className="item_owner_contact">
            <h5 className="owner_contact_title">⁍ Lastnik oglasa</h5>
            <div className="owner_contact d-flex align-items-center">
                <div className="owner_image">
                    <img
                        src="https://slike.bazarc.si/User_Icon.svg"
                        alt="slika uporabnika"
                    />
                </div>
                <div className="owner_name">
                    <div className="d-flex align-items-center gap-2">
                        <h5 className="owner_name_title mb-0">{username}</h5>
                        {/* Klic funkcije za prikaz značke */}
                        {renderVerificationBadge()}
                    </div>
                    <p
                        className="owner_all_items"
                        onClick={handleViewAllAds}
                        style={{ cursor: "pointer", textDecoration: "underline" }}
                    >
                        Prikaži vse oglase prodajalca
                    </p>
                </div>
            </div>
            <div className="owner_number">
                {showPhone ? (
                    <motion.div
                        className="phone_number"
                        initial={{ opacity: 0, scale: 0.8 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.5 }}
                    >
                        {user_phone_number ? (
                            <a href={`tel:${user_phone_number}`} className="phone_number show">
                                {user_phone_number}
                            </a>
                        ) : (
                            <span className="no-phone">Ni številke</span>
                        )}
                    </motion.div>
                ) : (
                    <button
                        className="btn btn-success phone_button"
                        onClick={() => setShowPhone(true)}
                    >
                        <i className="fas fa-phone"></i> Klikni za prikaz številke
                    </button>
                )}
            </div>
        </div>
    );
};

export default AdDetailsOwnerContact;